<template>
    <iframe class="iframe" :src="html" height="100%" width="100%">
    </iframe>
</template>

<script>


export default {
    name: "MarketingMaterials",
    components: {

    },
    computed: {

    },

    data() {
        return {
            html: 'https://www.lenta.pl/portal-zamowienie/'
        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>

<style scoped>
.iframe {
    min-height: 100rem;
    height: max-content;
}
</style>
